<script setup lang="ts">
import { onBeforeUnmount, onMounted, useTemplateRef } from "vue";

import { logger } from "@/shared/lib";

import { loadTurnstile } from "../lib";
import { useCaptchaStore } from "../model";

const captchaStore = useCaptchaStore();
const container = useTemplateRef<HTMLElement>("container");

let removeWidget: (() => void) | null = null;

onMounted(async () => {
    if (!captchaStore.isRequired || !container.value) return;

    try {
        const turnstile = await loadTurnstile();

        // The component could be unmounted while the script was loading
        if (!container.value) return;

        const widgetId = turnstile.render(container.value, {
            sitekey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
            callback: () => (captchaStore.isPassed = true),
            "error-callback": () => (captchaStore.isPassed = false),
            "expired-callback": () => (captchaStore.isPassed = false),
            size: "flexible",
            theme: "light",
        });

        if (widgetId) removeWidget = () => turnstile.remove(widgetId);
    } catch (error) {
        // As in v2: if Turnstile is unavailable the user must not be blocked
        logger.error("captcha is not rendered", error);
        captchaStore.isPassed = true;
    }
});

onBeforeUnmount(() => removeWidget?.());
</script>

<template>
    <div v-if="captchaStore.isRequired" ref="container" class="captcha" />
</template>

<style scoped>
.captcha {
    margin-top: 16px;
}
</style>
